import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import StyledComponent from '~/components/Styled/Styled';
import css from '~/components/CardHeader/CardHeader.scss';

const cssContext = classnames.bind(css);

class CardHeader extends React.PureComponent {
  render() {
    const classes = cssContext(css.header, {
      disableFlex: this.props.disableFlex,
    });

    return <div className={classes}>{this.props.children}</div>;
  }
}

CardHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  disableFlex: PropTypes.bool.isRequired,
};

CardHeader.displayName = 'CardHeader';
CardHeader.disableFlex = false;

export default StyledComponent(CardHeader, [css]);
